import '@fontsource/inter';
import "@fontsource/inter/200.css"
import "@fontsource/inter/600.css"
import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      '"Inter"',
      'arial',
      'helvetica',
      'sans-serif'
    ].join(','),
  },
  palette: {
    primary: {
      main: '#af5cf8'
    },
    secondary: {
      main: '#0066ff'
    },
    background: {
        default: '#ffffff'
    },
    text: {
      primary: "#272733"
    },
    info: {
      main: '#0066FF',
    },
    success: {
      main: '#00C05B',
    }
  },
  props: {
    // Name of the component ⚛️
    MuiButtonBase: {
      // The properties to apply
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
  },
});

export default theme;
